module.exports = __webpack_public_path__ + "img/img12.e7789468.svg";